import React, { ReactElement } from 'react';
import { Flex, Stack } from '@grubhubprod/gh-cookbook-react/dist';

export interface SignupStepFooterActionsTwoButtonsProps {
  back?: ReactElement;
  next: ReactElement;
}

export function SignupStepFooterActionsTwoButtons({
  back,
  next,
}: SignupStepFooterActionsTwoButtonsProps): JSX.Element {
  return (
    <Flex width="100%" justifyContent="flex-end" alignItems="center">
      {back && <Stack x="x-sm">{back}</Stack>}
      {next}
    </Flex>
  );
}
